import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const MobileIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M15.5829 0.771429C16.4918 0.771429 17.2286 1.50824 17.2286 2.41714V17.2286H0.771429V2.41714C0.771429 1.50824 1.50824 0.771429 2.41714 0.771429H15.5829ZM5.29714 3.24C4.16101 3.24 3.24 4.16101 3.24 5.29714C3.24 6.43327 4.16101 7.35429 5.29714 7.35429C6.43327 7.35429 7.35429 6.43327 7.35429 5.29714C7.35429 4.16101 6.43327 3.24 5.29714 3.24Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

MobileIcon.displayName = 'MobileIcon';
